import {invalidateOnSuccess, omneticApi} from '@dms/api/base';

import {
  carPassConfigResponseBodySchema,
  DeleteCarPassConfigApiArg,
  DeleteCarPassConfigApiResponse,
  GetCarPassConfigApiArg,
  GetCarPassConfigApiResponse,
  PatchCarPassConfigApiArg,
  PatchCarPassConfigApiResponse,
  patchCarPassConfigRequestBodySchema,
} from './types';

const carpassSettingsApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getCarPassConfig: build.query<GetCarPassConfigApiResponse, GetCarPassConfigApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/tenant/integrated-service/car-pass/${queryArg.branchId}`,
      }),
      providesTags: (result, error, queryArg) => [{type: 'CarpassConfig', id: queryArg.branchId}],
      extraOptions: {
        responseSchema: carPassConfigResponseBodySchema,
      },
    }),
    patchCarPassConfig: build.mutation<PatchCarPassConfigApiResponse, PatchCarPassConfigApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/tenant/integrated-service/car-pass/${queryArg.branchId}`,
        method: 'PATCH',
        body: queryArg.patchCarPassConfigRequestBody,
      }),
      invalidatesTags: invalidateOnSuccess((result, queryArg: PatchCarPassConfigApiArg) => [
        {type: 'CarpassConfig', id: queryArg.branchId},
      ]),
      extraOptions: {
        requestSchema: patchCarPassConfigRequestBodySchema,
      },
    }),
    deleteCarPassConfig: build.mutation<DeleteCarPassConfigApiResponse, DeleteCarPassConfigApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/tenant/integrated-service/car-pass/${queryArg.branchId}`,
        method: 'DELETE',
      }),
      invalidatesTags: invalidateOnSuccess((result, queryArg: DeleteCarPassConfigApiArg) => [
        {type: 'CarpassConfig', id: queryArg.branchId},
      ]),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCarPassConfigQuery,
  usePatchCarPassConfigMutation,
  useDeleteCarPassConfigMutation,
} = carpassSettingsApi;
